// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#organisation-screen[data-v-90e8ccf8]{display:-webkit-box;display:-ms-flexbox;display:flex;position:absolute;top:0;bottom:0;left:0;right:0}#organisation-screen .full-window[data-v-90e8ccf8]{position:fixed;left:0;right:0;top:0;bottom:0;z-index:1039}", ""]);
// Exports
module.exports = exports;
